import React, { useState } from 'react';

function ContactForm() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [status, setStatus] = useState(''); // '', 'sending', 'success', 'error'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://ss.tanveersingh.online/api/contact-submit.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
        setFormData({ fullName: '', email: '', phone: '', service: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <section className="tc-contact-form-style1">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-4">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <h3 className="fsz-45 fw-500 mb-80">
                Let us helps build your dream!
              </h3>
              <p className="fsz-14 color-666 mt-15">
                Your email address will not be published. <br /> Required fields
                are marked <span className="text-danger"> * </span>
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <form
              className="form mt-5 mt-lg-0 wow fadeInUp slow"
              data-wow-delay="0.4s"
              onSubmit={handleSubmit}
            >
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label>Full name <span className="color-orange1"> * </span></label>
                    <input
                      type="text"
                      name="fullName"
                      className="form-control"
                      placeholder="your name"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label>email address <span className="color-orange1">*</span></label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your email address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label>Phone <span className="color-999"> (optional) </span></label>
                    <input
                      type="text"
                      name="phone"
                      className="form-control"
                      placeholder="Your phone number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label>Service <span className="color-orange1"> * </span></label>
                    <select
                      name="service"
                      className="form-select form-control"
                      value={formData.service}
                      onChange={handleChange}
                      required
                    >
                      <option value=""> Select a Service </option>
                      <option value="Architecture & Exterior Designing">Architecture & Exterior Designing</option>
                      <option value="Interior Design">Interior Design</option>
                      <option value="Furniture Design">Furniture Design</option>
                      <option value="Project Consultation">Project Consultation</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group mb-30">
                    <label>message</label>
                    <textarea
                      name="message"
                      rows="6"
                      placeholder="Write your message here"
                      className="form-control"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                className="butn hover-bg-orange1 text-capitalize bg-white rounded-pill mt-40"
                disabled={status === 'sending'}
              >
                <span>
                  {status === 'sending' ? 'Sending...' : 'Send Your Message'}
                  <i className="fal fa-arrow-up-right ms-2"></i>
                </span>
              </button>

              {status === 'success' && <p className="text-success mt-3">Thank you! Your message has been sent.</p>}
              {status === 'error' && <p className="text-danger mt-3">Something went wrong. Please try again.</p>}

              <p className="fsz-12 color-666 mt-20">
                By submitting, I agree to the{' '}
                <a href="#" className="color-000 text-decoration-underline">
                  Terms & Conditions
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
      <img
        src="/innerpages/assets/img/contact_shap.png"
        alt=""
        className="shap"
      />
    </section>
  );
}

export default ContactForm;